<template>
  <div class="container">
    <div class="row">
      <div class="col-12 bg-white mb-3 card-border p-4 z-index-2 mx-auto">
        <div class="row" v-if="result === null">
          <div class="col-12">
            <div>
              <div class="d-md-none">
                <p class="p-sm pt-2 text-secondary1">
                  La cantidad de sueño que necesitás depende de varios factores, especialmente de tu edad.<br />Ingresá
                  tus
                  datos para conocer cuántas horas hay que dormir para tener una vida saludable.
                </p>
              </div>
              <div class="row justify-content-center d-none d-md-flex">
                <div class="col-10 d-block text-center w-100">
                  <p class="pt-2 font-Pr4 text-secondary1">
                    La cantidad de sueño que necesitás depende de varios factores, especialmente de tu
                    edad.<br />Ingresá
                    tus
                    datos para conocer cuántas horas hay que dormir para tener una vida saludable.
                  </p>
                </div>
              </div>
            </div>
            <div class="row mx-0 justify-content-center">
              <div class="col-md-8 p-0">
                <form @submit.prevent="getCalculation()">
                  <div class="row mx-0 justify-content-center">
                    <div class="col-md-12 col-lg-10 px-0">
                      <div class="py-3">
                        <span>
                          <div class="form-group mb-3" :class="{ error: ageError }">
                            <label for="age" class="label-sm font-Pr4 text-secondary1">Edad:</label>
                            <div class="col-md-12 px-0">
                              <div class="w-100 d-flex font-AR">
                                <div class="w-100 position-relative" ref="ageDropdownRef">
                                <button
                                  class="font-Pr4 dropdown-toggle w-100 text-start p-0"
                                  :class="{ selected: formInputs.age }"
                                  type="button"
                                  id="ageDropdown"
                                  @click="toggleDropdown"
                                  aria-expanded="false"
                                >
                                  <p class="mb-0 font-A400 pl-3 text-start">
                                    {{ formInputs.age ? formInputs.age.name : 'Ej: 40 años' }}
                                  </p>
                                </button>

                                <div
                                  class="dropdown-menu mt-0"
                                  :class="{ show: ageDropdownOpen }"
                                  aria-labelledby="ageDropdown"
                                  style="left: 0; right: 0; min-width: 0;"
                                >
                                  <a
                                    class="dropdown-item full-width-item d-flex align-items-center"
                                    href="#"
                                    v-for="option in ageOptions"
                                    :key="option.value"
                                    @click.prevent="selectAge(option)"
                                  >
                                    {{ option.name }}
                                  </a>
                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        </span>

                        <span>
                          <div class="form-group mb-3" :class="{ error: sleepHoursError }">
                            <label for="sleepHours" class="label-sm font-Pr4 text-secondary1">Horas de sueño:</label>
                            <div class="col-md-12 px-0">
                              <div class="w-100 d-flex font-AR">
                                <div class="w-100 position-relative" ref="sleepDropdownRef">
                                  <button
                                    class="font-Pr4 dropdown-toggle w-100 text-start p-0"
                                    :class="{ selected: formInputs.sleepHours }"
                                    type="button"
                                    id="sleepHoursDropdown"
                                    @click="toggleSleepDropdown"
                                    aria-expanded="false"
                                  >
                                    <p class="mb-0 font-A400 pl-3 text-start">
                                      {{ formInputs.sleepHours ? formInputs.sleepHours.name : 'Ej: Menos de 6 horas' }}
                                    </p>
                                  </button>

                                  <div
                                    class="dropdown-menu mt-0"
                                    :class="{ show: sleepHoursDropdownOpen }"
                                    aria-labelledby="sleepHoursDropdown"
                                    style="left: 0; right: 0; min-width: 0;"
                                  >
                                    <a
                                      class="dropdown-item full-width-item d-flex align-items-center"
                                      href="#"
                                      v-for="option in sleepHoursOptions"
                                      :key="option.value"
                                      @click.prevent="selectSleepHours(option)"
                                    >
                                      {{ option.name }}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </span>
                      </div>

                      <div class="text-center">
                        <button class="btn btn-outline-primary my-3 font-A12 text-uppercase h-50-px custom-width"
                          type="submit" :disabled="!formIsValid">
                          <strong>Calcular</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12 text-center">
            <span class="h4 font-Pr7 d-block text-secondary1 my-3">Según tus datos:</span>
            <div>
              <p class="text-primary mb-0 d-inline font-Pr">Edad: </p>
              <p class="text-dark mb-0 d-inline font-Pr">{{ formInputs.age.name }}</p>
            </div>
            <div>
              <p class="text-primary mb-0 d-inline font-Pr">Sueño: </p>
              <p class="text-dark mb-0 d-inline font-Pr">{{ formInputs.sleepHours.name }}</p>
            </div>
            <p class="h3-md text-secondary1 my-4 font-Pr7">{{ result.title }}</p>
            <p class="h4 font-P20 text-secondary1">
              Tu descanso recomendado es de<br class="custom-break" />
              <span class="font-P7">{{ result.recommendedRest }}</span>
            </p>
            <button class="mt-4 btn btn-outline-primary h-50-px font-A12 text-uppercase w-289" @click="onReset()">
              <strong>
                Calcular nuevamente
              </strong>
            </button>
          </div>
          <div class="col-12">
            <p class="text-secondary1 h4 font-P7 mt-5 mb-3">
              ¿Por qué es importante dormir bien?
            </p>
            <p class="p-sm text-secondary2 font-Pr">
              Descansar bien es clave para disfrutar de una vida sana. Sin embargo, en
              la Argentina hay un déficit de sueño colectivo elevado porque sus
              habitantes se caracterizan por tener hábitos nocturnos, lo que impacta
              en la calidad de su descanso. Este test le permitirá saber si duerme el
              tiempo que necesita, o si tiene que mejorar sus hábitos para lograr un
              mayor bienestar.
            </p>
            <hr />
            <div class="px-md-4">
              <p class="small mt-4 text-secondary2 font-A400">
                * La información es de referencia, se aconseja consultar a un médico.
                Todas las decisiones que se tomen en base a este relevamiento son
                responsabilidad de cada persona.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      ageDropdownOpen: false,
      sleepHoursDropdownOpen: false,
      formInputs: {
        age: null,
        sleepHours: null,
      },
      ageError: null,
      sleepHoursError: null,
      result: null,
      ageOptions: this.createAgeOptions(),
      sleepHoursOptions: this.createSleepHoursOptions(),
    };
  },
  computed: {
    formIsValid() {
      return this.formInputs.age !== null && this.formInputs.sleepHours !== null;
    }
  },
  methods: {
    toggleDropdown() {
      this.ageDropdownOpen = !this.ageDropdownOpen;
    },
    toggleSleepDropdown() {
      this.sleepHoursDropdownOpen = !this.sleepHoursDropdownOpen;
    },
    selectAge(option) {
      this.formInputs.age = option;
      this.ageDropdownOpen = false;
      this.validateForm();
    },
    selectSleepHours(option) {
      this.formInputs.sleepHours = option;
      this.sleepHoursDropdownOpen = false;
      this.validateForm();
    },
    validateForm() {
      this.ageError = this.formInputs.age ? null : 'La edad es requerida';
      this.sleepHoursError = this.formInputs.sleepHours ? null : 'Las horas de sueño son requeridas';
    },
    getCalculation() {
      const ageValue = this.formInputs.age.value;
      const sleepHoursValue = this.formInputs.sleepHours.value;
      this.result = {}

      switch (ageValue) {
        // Recién nacidos (0-3 meses):
        case 1:
          this.result.recommendedRest = 'entre 14 y 17 horas por día'

          if (sleepHoursValue < 11) {
            this.result.title = 'Faltan horas de sueño'
          } else if (sleepHoursValue >= 11 && sleepHoursValue <= 13) {
            this.result.title = 'Estate atento'
          } else if (sleepHoursValue >= 14 && sleepHoursValue <= 17) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }

          break;

        // Bebés (4-11 meses):
        case 2:
          this.result.recommendedRest = 'entre 12 y 15 horas por día'

          if (sleepHoursValue < 11) {
            this.result.title = 'Faltan horas de sueño'
          } else if (sleepHoursValue >= 11 && sleepHoursValue <= 12) {
            this.result.title = 'Estate atento'
          } else if (sleepHoursValue >= 13 && sleepHoursValue <= 15) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }

          break;

        // Niños pequeños (1-2):
        case 3:
          this.result.recommendedRest = 'entre 11 y 14 horas por día'

          if (sleepHoursValue < 10) {
            this.result.title = 'Faltan horas de sueño'
          } else if (sleepHoursValue >= 11 && sleepHoursValue <= 14) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }

          break;

        // Niños en edad preescolar (3-5):
        case 4:
          this.result.recommendedRest = 'entre 8 y 13 horas por día'

          if (sleepHoursValue < 7) {
            this.result.title = 'Faltan horas de sueño'
          } else if (sleepHoursValue >= 8 && sleepHoursValue <= 13) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }

          break

        // Niños en edad escolar (6-13):
        case 5:
          this.result.recommendedRest = 'entre 9 y 11 horas por día'

          if (sleepHoursValue < 9) {
            this.result.title = 'Faltan horas de sueño'
          } else if (sleepHoursValue >= 9 && sleepHoursValue <= 11) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }
          break;

        // Adolescentes (14-17):
        case 6:
          this.result.recommendedRest = 'entre 10 y 11 horas por día'

          if (sleepHoursValue < 10) {
            this.result.title = 'Faltan horas de sueño'
          } else if (sleepHoursValue >= 10 && sleepHoursValue <= 11) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }
          break;

        // Adultos más jóvenes (18 a 25):
        // Adultos (26-64):
        // Adultos mayores, más de 64 años
        case 7:
        case 8:
        case 9:
          this.result.recommendedRest = 'entre 7 y 9 horas por día'

          if (sleepHoursValue < 7) {
            this.result.title = 'Te faltan horas de sueño'
          } else if (sleepHoursValue >= 7 && sleepHoursValue <= 9) {
            this.result.title = 'Buenas noticias'
          } else {
            this.result.title = 'Cuidado'
          }
          break
        default:
          return;
      }
    },
    receiveFormInputs(value) {
      this.formInputs = value
    },
    onReset() {
      this.result = null;
      this.formInputs.sleepHours = null;
      this.formInputs.age = null;
      this.ageDropdownOpen = false;
      this.sleepHoursDropdownOpen = false;
      this.ageError = null;
      this.sleepHoursError = null;
    },
    createAgeOptions() {
      const ageOptionsArr = [
        'Recién nacidos (0-3 meses)',
        'Bebés (4-11 meses)',
        'Niños pequeños (1-2)',
        'Niños en edad preescolar (3-5)',
        'Niños en edad escolar (6-13)',
        'Adolescentes (14-17)',
        'Adultos más jóvenes (18 a 25)',
        'Adultos (26-64)',
        'Adultos mayores, más de 64 años'
      ];

      return ageOptionsArr.map((item, index) => ({
        value: index + 1,
        name: item
      }));
    },
    createSleepHoursOptions() {
      const sleepOptionsArr = Array.from({ length: 17 }, (_, i) => i + 1);

      return sleepOptionsArr.map(item => ({
        value: item,
        name: item === 1 ? '1 hora' : item === 17 ? `+${item} horas` : `${item} horas`
      }));
    },
    handleClickOutside(event) {
      if (this.$refs.ageDropdownRef && !this.$refs.ageDropdownRef.contains(event.target)) {
        this.ageDropdownOpen = false;
      }
      if (this.$refs.sleepDropdownRef && !this.$refs.sleepDropdownRef.contains(event.target)) {
        this.sleepHoursDropdownOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
